import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';

/**
 * Hook to listen to a single tag document live.
 * 
 * @param {string} tagId - The ID of the tag to listen to
 * @returns {[boolean, Object, any]} [loading, tagData, error]
 */
export function useTag(tagId) {
  const [tag, setTag] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tagId) {
      setTag(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    const db = firebase.firestore();
    const ref = db.collection('tags').doc(tagId);

    const unsubscribe = ref.onSnapshot((snap) => {
      if (snap.exists) {
        setTag({ id: snap.id, ...snap.data() });
      } else {
        setTag(null);
      }
      setLoading(false);
    }, (err) => {
      console.error("useTag snapshot error:", err);
      setError(err);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [tagId]);

  return [loading, tag, error];
}

